export enum MotoristaTypes {
  'LOAD_REQUEST' = '@motorista/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@motorista/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@motorista/LOAD_FAILURE',

  'LOAD_DETALHES_REQUEST' = '@motorista/LOAD_DETALHES_REQUEST',
  'LOAD_DETALHES_SUCCESS' = '@motorista/LOAD_DETALHES_SUCCESS',
  'LOAD_DETALHES_FAILURE' = '@motorista/LOAD_DETALHES_FAILURE',

  'CLEAN_MOTORISTA' = '@motorista/CLEAN_MOTORISTA',
  'FILTER' = '@motorista/FILTER',
}

export interface IMotorista {
  codMotorista: number;
  nome: string;
  cpf: string;
  mopp: boolean;
  habilitado: string;
  telefone: string;
  ativo: boolean;
}

export interface IDetalhesMotorista {
  codMotorista: number;
  nome: string;
  cpf: string;
  mopp: boolean;
  habilitado: string;
  telefone: string;
}

export interface IFilter {
  nome: string;
  cpf: string;
  mopp: boolean;
  habilitado: string;
}

export interface Pagination {
  total: number;
  pageSize: number;
  current: number;
  showSizeChanger: boolean;
  pageSizeOptions: string[];
}

export interface MotoristaState {
  readonly data: IMotorista[];
  readonly dataDetalhesMotorista: IMotorista[];
  readonly loading: boolean;
  readonly error: boolean;
  readonly filter: IFilter;
  readonly pagination: Pagination;
}
